import { createContext, useContext, useState, ReactNode, useCallback } from "react";
import { FormValues } from "../CreateCaseForm/types";

// Fields from CaseInformationCard that we want to retain
export type CaseInformationFormData = Pick<
  FormValues,
  | "hasSubscriptionUrl"
  | "prospectIdOrSubscriptionUrl"
  | "client"
  | "entity"
  | "assignToMyself"
  | "accountType"
  | "entityType"
  | "programName"
>;

type CaseFormContextType = {
  caseInformationData: Partial<CaseInformationFormData> | null;
  saveCaseInformationData: (data: Partial<CaseInformationFormData>) => void;
};

const CaseFormContext = createContext<CaseFormContextType | undefined>(undefined);

export const useCaseFormContext = () => {
  return useContext(CaseFormContext);
};

type CaseFormProviderProps = {
  children: ReactNode;
};

export const CaseFormProvider = ({ children }: CaseFormProviderProps) => {
  const [caseInformationData, setCaseInformationData] =
    useState<Partial<CaseInformationFormData> | null>(null);

  const saveCaseInformationData = useCallback((data: Partial<CaseInformationFormData>) => {
    setCaseInformationData(data);
  }, []);

  return (
    <CaseFormContext.Provider value={{ caseInformationData, saveCaseInformationData }}>
      {children}
    </CaseFormContext.Provider>
  );
};
